export default __webpack_public_path__ + "static/media/garden-06.569063f5.jpg";